import { CircularProgress } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

// The small ring beside Settings (MI-354), only once a budget reaches WARN_AT:
// amber while it fills, red once it is spent, as the Plan section's bars. Its
// label says which budget and how much. `mark` is aiUsageMark's.
export default function AiUsageRing({ mark, size = '14px' }) {
  const { t } = useTranslation('navigation');
  if (!mark) return null;
  const { window, percent, reached } = mark;
  const month = window === 'month';
  const label = reached
    ? t(month ? 'aiUsage.reachedMonth' : 'aiUsage.reachedDay')
    : t(month ? 'aiUsage.nearMonth' : 'aiUsage.nearDay', { percent });
  return (
    <CircularProgress
      value={percent}
      size={size}
      thickness="16px"
      color={reached ? 'red.500' : 'orange.500'}
      trackColor="redesign.bg.sunken"
      capIsRound
      title={label}
      aria-label={label}
      display="flex"
    />
  );
}
